import axios from 'axios'
import Constants from '../constants'

export default {
  getTickets: (params, lang) => {
    const { viaLists, stations } = params
    return new Promise((resolve) => {
      axios.get('recommendTicket', { params: { id : Constants.API_ID, language: lang, viaLists: viaLists, stations: stations } })
        .then(payload => {
          resolve(payload.data.section)
        })
    })
  },
}